import Layout from "./Layout.jsx";
import ApproveMaterial from "../components/ApproveMaterial.jsx";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getMe } from "../features/authSlice.js";

function ApproveMaterialPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);

  return (
    <>
      {user && (
        <Layout>
          <ApproveMaterial></ApproveMaterial>
        </Layout>
      )}
      {/* Add a loader or handle unauthorized access */}
    </>
  );
}

export default ApproveMaterialPage;
